import { render, staticRenderFns } from "./wordBreak-editor.vue?vue&type=template&id=7a99919a&scoped=true"
import script from "./wordBreak-editor.vue?vue&type=script&lang=js"
export * from "./wordBreak-editor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a99919a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7a99919a')) {
      api.createRecord('7a99919a', component.options)
    } else {
      api.reload('7a99919a', component.options)
    }
    module.hot.accept("./wordBreak-editor.vue?vue&type=template&id=7a99919a&scoped=true", function () {
      api.rerender('7a99919a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form-designer/setting-panel/property-editor/container-table-cell/wordBreak-editor.vue"
export default component.exports